<template>
  <div>
    <v-app-bar dark app fixed>
      <v-toolbar-title style="cursor: pointer" @click="toHomePage">{{ getName }}</v-toolbar-title>

      <template v-if="extension" v-slot:extension>
        <slot name="extension"/>
      </template>
      <v-spacer/>
      <template v-if="$vuetify.breakpoint.smAndUp" v-for="(item, i) in barItems">
        <v-badge
          color="red"
          content="New"
          :value="item.isNew"
          offset-x="30"
          offset-y="8"
        >
          <v-btn :key="i" text :to="item.path" exact @click="refreshPage(item.path)">{{ item.name }}
            <v-chip v-if="midAutumnActive && item.path && item.path.name === 'message'" x-small color="yellow" text-color="black" class="ml-1">中秋</v-chip>
          </v-btn>
        </v-badge>
      </template>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        min-width="300"
        max-width="90%"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-badge
              color="red"
              :content="notification.count > 99 ? '99+' : notification.count"
              :value="notification.count"
            >
              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-card width="400">
          <v-card-title class="pb-1">通知</v-card-title>
          <v-card-text style="max-height: 80vh" class="overflow-y-auto">
            <v-sheet>
              <div class="d-flex">
                <div class="text-subtitle-1 align-self-center">系統公告
                  <v-avatar v-if="notification.notices" color="red" size="18" style="vertical-align: baseline">
                    <span class="white--text text-caption" v-text="notification.notices"/>
                  </v-avatar>
                </div>
                <v-spacer/>
                <v-btn text color="grey darken-1" :to="{name: 'notice'}" class="px-1" active-class="no-active"
                       @click="refreshPage({name: 'notice'})">查看全部
                </v-btn>
              </div>
              <v-list v-show="notices.length">
                <v-list-item
                  v-for="notice in notices"
                  :key="notice.id"
                  class="mb-1 px-1 no-active"
                  @click="setRead(notice)"
                >
                  <v-list-item-content class="pa-0">
                    <v-badge :value="!parseInt(notice.is_read)" color="red" dot offset-x="9" offset-y="10" class="mb-0">
                      <div class="d-flex">
                        <v-img v-if="notice.file_name" :src="notice.file_name" max-width="60" max-height="60"
                               class="mr-2 align-self-center"/>
                        <v-img v-else src="https://dentco.s3.us-east-2.amazonaws.com/asset/crm/logo_square.webp"
                               max-width="60" max-height="60"
                               class="mr-2 align-self-center"/>
                        <div class="flex-fill">
                          <div class="text--secondary text-caption mb-1">{{ notice.created_at | shortDate }}</div>
                          <div class="text-pre-line overflow-hidden multiline-ellipsis" v-text="notice.content"
                               style="max-height: 47px; word-break: break-all"/>
                        </div>
                      </div>
                    </v-badge>

                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div v-show="!notices.length" class="text-center grey--text text--darken-1 mt-2">
                目前沒有任何系統公告
              </div>
            </v-sheet>
            <v-divider/>
            <v-sheet>
              <div class="d-flex align-center">
                <div class="text-subtitle-1">真人客服請求
                  <v-avatar v-if="notification.ai_human_support" color="red" size="18" style="vertical-align: baseline">
                    <span class="white--text text-caption" v-text="notification.ai_human_support"/>
                  </v-avatar>
                </div>
                <v-spacer/>
                <v-btn v-if="allowedPath({name: 'AICustomerService'})" text color="grey darken-1" :to="{name: 'AICustomerService', query: {tab: 'history'}}" class="px-1" active-class="no-active"
                       @click="menu = false">
                  查看全部
                </v-btn>
              </div>
              <v-list v-show="humanSupportItems.length" class="py-0">
                <v-list-item
                  v-for="item in humanSupportItems"
                  :key="item.id"
                  class="mb-1 px-1 no-active"
                  v-on="allowedPath({name: 'AICustomerService'}) ? { click: () => openHumanSupport(item) } : {}"
                >
                  <v-list-item-content class="pa-0">
                    <v-badge :value="!item.isRead" color="red" dot offset-x="9" offset-y="10" class="mb-0">
                      <div class="d-flex">
                        <v-icon color="primary" size="44" class="mr-3 align-self-center">mdi-account-voice</v-icon>
                        <div class="flex-fill human-support-content">
                          <div class="text--secondary text-caption mb-1">{{ item.date }}</div>
                          <div class="font-weight-medium" v-text="item.title"/>
                          <div class="text-pre-line overflow-hidden multiline-ellipsis" v-text="item.display_content || item.content"/>
                        </div>
                      </div>
                    </v-badge>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div v-show="!humanSupportItems.length" class="text-center grey--text text--darken-1 mt-2 mb-3">
                目前沒有真人客服請求
              </div>
            </v-sheet>
            <v-divider/>
            <notification-card
              :items="appointments"
              no-data="沒有未處理的線上約診"
              title="線上約診"
              :count="notification.appointments"
              :to-path="allowedPath({name: 'onlineReserve'})"
              :get-content="appointmentContent"
              @refresh="refreshPage"
            />
            <v-divider/>
            <notification-card
              :items="negativeReviewItems"
              no-data="沒有未讀的站內負面評論"
              title="即時負評通知"
              :count="notification.negative_review"
              :to-path="allowedPath({name: 'reviewList'})"
              :get-content="negativeReviewContent"
              :get-date-time="negativeReviewDateTime"
              @refresh="refreshPage"
            />
            <v-divider/>
            <notification-card
              :items="rescheduleItems"
              no-data="沒有未處理的改約名單"
              title="改約名單"
              :count="notification.change_reserves"
              :to-path="allowedPath({name: 'reschedule'})"
              :get-content="rescheduleContent"
              @refresh="refreshPage"
            />
            <notification-card
              :items="doctorCareItems"
              no-data="沒有未處理的關懷通知"
              title="關懷名單"
              :count="notification.care"
              :to-path="allowedPath({name: 'operativeCare'})"
              :get-content="doctorCareContent"
              @refresh="refreshPage"
            />
          </v-card-text>
        </v-card>
      </v-menu>
      <v-app-bar-nav-icon @click.stop="toggleDrawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="isDrawerOpenComputed" app temporary dark right :stateless="lockNavDrawer" height="100%">
      <v-list nav dense>
        <v-list-item-group v-model="group" dark mandatory>
          <v-list-item v-for="(item, index) in navItems" :to="item.path" exact :key="index"
            :style="{ display: item.hidden ? 'none' : '' }" :id="item.id"
            @click="handleNavItemClick(item)"
            @change="isDrawerOpenComputed = false"
          >
            <template >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.name }} {{ item.isNew ? '🔥' : '' }}
                <v-chip v-if="midAutumnActive && item.path && item.path.name === 'message'" x-small color="yellow" text-color="black" class="ml-1">中秋</v-chip>
              </v-list-item-title>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <div class="px-2 pt-2 pb-8">
          <v-btn v-if="isRoot" block color="blue-6" class="mb-2" :to="{name: 'accountSettings'}">修改帳號密碼</v-btn>
          <v-btn block color="primary" @click="clearUserData">
            {{ $t('Navigation.logout') }}
          </v-btn>
          <v-btn v-if="isSuper" :to="{name: 'switchAccount'}" block class="mt-2" color="red-6">
            神秘按鈕
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <reserve-common-note-settings-dialog
      v-if="clinicUser"
      v-model="reserveCommonNoteSettingsDialog"
    />

  </div>
</template>

<script>
import midAutumnPromotion from '@/mixins/midAutumnPromotion';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import {
  getAppointmentAPI,
  getCareAPI,
  getChatNotificationAPI,
  getRescheduleAPI,
  getTopNoticeAPI,
  getUnreadNegativeReviewAPI,
  setChatNotificationReadAPI,
} from "../api";
import { formatDate, shortDate } from "../utils/filters";
import NotificationCard from "./NotificationCard";
import ReserveCommonNoteSettingsDialog from './reserve/ReserveCommonNoteSettingsDialog';
import { permissionMixin, getParentPermissionName, canAccessRoute } from "@/utils/permission";
import { CRM_JWT_ENABLED, requiresCrmLogin } from '@/api/crm-auth';
import { crmToolLaunchError, requestCrmToolLaunchUrl } from '@/api/crm-tool';
import { CRM_MESSENGER_READ_EVENT, dispatchCrmMessengerRead } from "@/utils/crmMessengerReadEvent";

export default {
  name: "Navigation",
  components: {NotificationCard, ReserveCommonNoteSettingsDialog},
  mixins: [permissionMixin, midAutumnPromotion],
  props: {
    extension: Boolean,
  },
  data() {
    return {
      drawer: null,
      group: null,
      menu: false,
      notices: [],
      humanSupportItems: [],
      appointments: [],
      rescheduleItems: [],
      negativeReviewItems: [],
      doctorCareItems: [],
      checkNotificationTimer: null,
      reserveCommonNoteSettingsDialog: false,
      pendingCrmTools: [],
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      notification: state => state.notification,
    }),
    ...mapGetters([
      'clinicUser',
      'doctorUser',
      'axiosParamData',
      'isSpecialClinic',
      'isSuper',
      'isRoot'
    ]),
    navItems() {
      let items = [
        {
          path: {name: 'home'},
          icon: 'mdi-calendar-multiselect',
          name: this.$t('Navigation.reserveList'),
          showTop: {
            show: true,
            sort: 0,
          },
          isNew: false,
          canSpecial: false
        },
        {
          action: 'reserveCommonNotes',
          permissionName: 'home',
          icon: 'mdi-note-edit-outline',
          name: this.$t('Navigation.reserveCommonNotes'),
          isNew: false,
          canSpecial: false,
          hidden: !this.clinicUser,
        },
        {
          path: {name: 'onlineReserve'},
          icon: 'mdi-calendar-plus',
          name: this.$t('Navigation.onlineReserveList'),
          showTop: {
            show: true,
            sort: 1,
          },
          isNew: false,
          canSpecial: true
        },
        {
          path: {name: 'reschedule'},
          icon: 'mdi-calendar-remove',
          name: this.$t('Navigation.reschedule'),
          showTop: {
            show: true,
            sort: 2,
          },
          isNew: false,
          canSpecial: true
        },
        {
          path: {name: 'patients'},
          icon: 'mdi-account-settings',
          name: this.$t('Navigation.patientList'),
          isNew: false,
          canSpecial: false
        },
        {
          path: {name: 'freeTime'},
          icon: 'mdi-calendar-question',
          name: this.$t('Navigation.freeTime'),
          showTop: {
            show: true,
            sort: 5,
          },
          isNew: false,
          canSpecial: true
        },
        {
          path: {name: 'review'},
          icon: 'mdi-note-text-outline',
          name: this.$t('Navigation.reviewList'),
          isNew: false,
          canSpecial: true
        },
        {
          path: {name: 'upload'},
          icon: 'mdi-file-upload-outline',
          name: this.$t('Navigation.upload'),
          isNew: false,
          canSpecial: true
        },
        {
          path: { name: 'HealthEducationList' },
          icon: 'mdi-file-cog-outline',
          name: '客製化看診提醒',
          isNew: this.$moment() < this.$moment('2025-10-01'),
          canSpecial: true
        },
        {
          path: { name: 'CareTemplateList' },
          icon: 'mdi-message-cog-outline',
          name: '智能個案管理師',
          isNew: this.$moment() < this.$moment('2025-10-01'),
          canSpecial: true
        },
        {
          path: {name: 'settings'},
          icon: this.clinicUser ? 'mdi-home-edit-outline' : 'mdi-account-edit-outline',
          name: this.clinicUser ? this.$t('Navigation.clinicInfo') : this.$t('Navigation.doctorInfo'),
          isNew: false,
          canSpecial: true,
          id: 'tour-step-doctor-settings'
        },
        {
          path: {name: 'analytics'},
          icon: 'mdi-chart-line-variant',
          name: this.$t('Navigation.analytics'),
          isNew: false,
          canSpecial: true
        },
        {
          path: {name: 'adminSettings'},
          icon: 'mdi-cogs',
          name: this.$t('Navigation.adminSetting'),
          isNew: false,
          canSpecial: true
        },
        {
          path: {name: 'systemSettingsIndex'},
          icon: 'mdi-cogs',
          name: '系統權限設定',
          isNew: false,
          canSpecial: true
        },
        {
          path: {name: 'message'},
          icon: 'mdi-send-circle-outline',
          name: this.$t('Navigation.message'),
          isNew: false,
          showTop: {
            show: true,
            sort: 4,
          },
          canSpecial: true
        },
        {
          path: {name: 'operativeCare'},
          icon: 'mdi-hand-heart',
          name: '關懷名單',
          showTop: {
            show: true,
            sort: 3,
          },
          isNew: this.$moment() < this.$moment('2022-11-01'),
          canSpecial: true
        },
        // {
        //   path: { name: 'openaiConversation' },
        //   icon: 'mdi-robot',
        //   name: 'AI智能助理詢問紀錄',
        //   isNew: false,
        //   canSpecial: true
        // },
        {
          path: { name: 'AICustomerService' },
          icon: 'mdi-robot',
          name: 'AI智能客服',
          isNew: false,
          canSpecial: true
        },
        {
          ...(this.clinicUser ? {
            path: { name: 'question' },
            icon: 'mdi-comment-question-outline',
            name: this.$t('Navigation.questions'),
            isNew: false,
            canSpecial: true,
          } : {
            hidden: true
          })
        },
        {
          path: {name: 'superLink'},
          icon: 'mdi-link-plus',
          name: '連結小工具',
          isNew: false,
          canSpecial: true
        },
        // 外部工具入口：jwt 登入模式且部署旗標剛好是 'true' 才顯示（legacy 模式重新登入仍拿不到 JWT），點擊後以一次性通行證開新分頁。
        {
          action: 'crmTool',
          app: 'line-editor',
          icon: 'mdi-message-text-outline',
          name: this.$t('Navigation.lineKeywordEditor'),
          isNew: false,
          canSpecial: true,
          hidden: !CRM_JWT_ENABLED || process.env.VUE_APP_CRM_TOOL_LINE_EDITOR_ENABLED !== 'true',
        },
        {
          action: 'crmTool',
          app: 'crm-forum',
          icon: 'mdi-forum-outline',
          name: this.$t('Navigation.crmForum'),
          isNew: false,
          canSpecial: true,
          hidden: !CRM_JWT_ENABLED || process.env.VUE_APP_CRM_TOOL_FORUM_ENABLED !== 'true',
        },
        {
          path: {name: 'notice'},
          icon: 'mdi-bullhorn',
          name: '系統公告',
          isNew: false,
          canSpecial: true
        },
      ]

      // 過濾特殊診所
      if (this.isSpecialClinic)
        items = items.filter(e => e.canSpecial)

      // 醫師登入（type: "2"）不受權限系統影響，顯示所有選單
      const isDoctorLogin = this.user.type === '2'

      // 診所登入才過濾權限
      if (!isDoctorLogin) {
        // 過濾沒有權限的項目
        items = items.filter(item => {
          // 跳過已經被標記為 hidden 的項目
          if (item.hidden) return false

          // 取得路由名稱
          const routeName = item.path?.name

          // 系統公告：所有人可見，不受權限限制
          if (routeName === 'notice') return true

          // 特殊處理：「系統權限設定」只有 root 可見
          if (routeName === 'systemSettingsIndex' || routeName === 'SubAccountSettings') {
            return this.$isRoot || this.isSuper
          }

          // 外部工具沒有對應的頁面權限，只給主權限
          if (item.action === 'crmTool') {
            return this.$isRoot || this.isSuper
          }

          // 找到對應的權限名稱（處理子路由 → 父路由的對應）
          const permissionName = item.permissionName || getParentPermissionName(routeName)
          if (!permissionName) return true

          // 檢查是否有權限
          return this.$canAccess(permissionName)
        })
      }

      return items
    },
    getName() {
      if (this.clinicUser) {
        // 主權限只顯示診所名稱（使用 isRoot getter 正確處理字串/數字/布林值）
        if (this.isRoot) {
          return this.user.clinic_name
        }
        // 一般帳號顯示：診所名稱 - 使用者名稱
        return this.user.crm_user_name ? `${this.user.clinic_name} - ${this.user.crm_user_name}` : this.user.clinic_name
      } else if (this.doctorUser) {
        return this.user.doctor_name + this.$t('Navigation.doctor')
      }
    },
    barItems() {
      const showItems = this.navItems.filter(e => e.showTop && e.showTop.show)
      return showItems.sort((a, b) => {
        return a.showTop.sort - b.showTop.sort
      })
    },
    isDrawerOpenComputed: {
      get() {
        return this.$store.getters['navigation/isDrawerOpen']
      },
      set(isOpen) {
        this.$store.commit('navigation/setDrawerOpen', isOpen)
      }
    },
    lockNavDrawer() {
      return this.$store.getters['tour/lockNavDrawer']
    }
  },
  watch: {
    menu(v) {
      if (v) this.handleClickBell()
    }
  },
  methods: {
    ...mapMutations({
      clearUserData: 'clearUserData'
    }),
    allowedPath(to) {
      return canAccessRoute(to) ? to : null
    },
    ...mapActions({
      getUnreadNotice: 'getUnreadNotice',
      setNoticeRead: 'setNoticeRead',
    }),
    toggleDrawer() {
      this.$store.commit('navigation/setDrawerOpen', !this.isDrawerOpenComputed)
    },
    toHomePage() {
      if (this.$router.currentRoute.name !== 'home')
        this.$router.push({name: 'home'})
    },
    refreshPage(path) {
      if (path && this.$router.currentRoute.name === path.name) this.$router.go(0)
    },
    handleNavItemClick(item) {
      if (item.action === 'reserveCommonNotes') {
        this.reserveCommonNoteSettingsDialog = true
        this.isDrawerOpenComputed = false
        return
      }
      if (item.action === 'crmTool') return this.openCrmTool(item.app)
      this.refreshPage(item.path)
    },
    async openCrmTool(app) {
      if (this.pendingCrmTools.includes(app)) return
      this.isDrawerOpenComputed = false
      if (requiresCrmLogin(this.user, true)) return this.$notify.error('請重新登入 CRM 後再開啟此工具')
      // 必須在任何 await 之前同步開分頁，否則瀏覽器會當成彈出視窗封鎖。
      const tab = window.open('', '_blank')
      if (!tab) return this.$notify.error('瀏覽器封鎖了新分頁，請允許此網站開啟彈出視窗後再試一次')
      this.pendingCrmTools.push(app)
      try {
        const launchUrl = await requestCrmToolLaunchUrl(app)
        if (tab.closed) return
        tab.opener = null
        tab.location.replace(launchUrl)
      } catch (error) {
        // 401 invalid_token 已由 crmAuthHttp 交給既有的失效處理（清除登入、回登入頁）。
        tab.close()
        this.$notify.error(crmToolLaunchError(error))
      } finally {
        this.pendingCrmTools = this.pendingCrmTools.filter(pending => pending !== app)
      }
    },
    getTopNotices() {
      this.getUnreadNotice()
      getTopNoticeAPI(this.axiosParamData).then(res => {
        this.notices = res.data.slice(0, 3)
      })
    },
    setRead(notice) {
      this.setNoticeRead([notice.id]).then(() => {
        this.getTopNotices()
        this.menu = false
        const target = {name: 'notice', hash: `#notice-${notice.id}`}
        if (this.$router.currentRoute.name === 'notice') {
          this.$router.replace(target)
        } else {
          this.$router.push(target)
        }
      })
    },
    async openHumanSupport(item) {
      try {
        await setChatNotificationReadAPI({
          ...this.axiosParamData,
          id: item.id,
        })
        item.isRead = true
        dispatchCrmMessengerRead({source: 'bell', ids: [item.id]})
        await this.getUnreadNotice()
      } catch {
        await this.getUnreadNotice()
      }
      this.menu = false
      await this.$router.push({name: 'AICustomerService', query: {tab: 'history'}})
    },
    handleCrmMessengerRead(event) {
      const detail = event.detail || {}
      if (detail.source !== 'assistant') return

      this.humanSupportItems.forEach(item => {
        if (item.id <= detail.cursor) item.isRead = true
      })
      this.getUnreadNotice()
    },
    handleClickBell() {
      this.getTopNotices()
      getChatNotificationAPI({
        ...this.axiosParamData,
        direction: 'new',
        cursor: null,
        page_size: 3,
        message_type: 'ai_human_support',
      }).then(res => {
        this.humanSupportItems = res.data.contents.slice().reverse()
      })
      getAppointmentAPI({...this.axiosParamData, limit: 3, page: 1, status: 0}).then(res => {
        this.appointments = res.data.data
      })
      getRescheduleAPI(this.axiosParamData).then(res => {
        this.rescheduleItems = res.data.data.slice(0, 3)
      })
      getCareAPI({...this.axiosParamData, limit: 3, page: 1, reply_status: 0, care_status: '2'}).then(res => {
        this.doctorCareItems = res.data.data
      })
      getUnreadNegativeReviewAPI(this.axiosParamData).then(res => {
        this.negativeReviewItems = res.data.data
      })
    },
    appointmentContent(item) {
      return `${item.is_np === '0' ? '新患者' : '舊患者'} ${item.name}
      與 ${item.doctor_name}醫師 預約時間 ${item.book_time} ${item.item} 於 ${item.clinic_name}`
    },
    rescheduleContent(item) {
      return `原訂 ${shortDate(item.start_time)} ${item.doctor_name}醫師的預約已被病患 ${item.name} 點擊改約，
      病人選擇的改約原因：${item.change_reason}，病人選擇的是否聯繫：${item.call_clinic_status}。`
    },
    doctorCareContent(item) {
      const desc = item.care_type === 'pre' ? '反應術前疑問' : '反應治療後不適'
      return `${shortDate(item.start_time)}就診病人${item.name}${desc}，點擊查看更多資訊`
    },
    checkNotification() {
      clearTimeout(this.checkNotificationTimer)
      this.getUnreadNotice().then(() => {
        this.checkNotificationTimer = setTimeout(() => {
          this.checkNotification()
        }, 1000 * 60 * 60)
      })
    },
    negativeReviewContent(item) {
      switch (Number(item.type)) {
        case 1:
          return `您收到一筆來自 ${item.patient_name} 對於 ${ formatDate(item.reserve_start_date_time)} 於 ${item.clinic_name} ${item.doctor_name}${item.doctor_title} 的站內負面評價。`
        case 3:
          return `您收到一筆來自 ${item.patient_name} 的Google負面評價`
        default:
          return `您收到一筆來自 ${item.patient_name} 的負面評價`
      }
    },
    negativeReviewDateTime(item) {
      return formatDate(item.created_at)
    }
  },
  mounted() {
    window.addEventListener(CRM_MESSENGER_READ_EVENT, this.handleCrmMessengerRead)
    this.checkNotification()
  },
  beforeDestroy() {
    window.removeEventListener(CRM_MESSENGER_READ_EVENT, this.handleCrmMessengerRead)
    clearTimeout(this.checkNotificationTimer)
  },
}
</script>

<style scoped>
.multiline-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.v-list-item--active.no-active::before {
  display: none
}

.human-support-content {
  min-width: 0;
  word-break: break-word;
}
</style>
